<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { AccordionItem } from '@squareup/public-web-design-system';
  import DynamicChildrenComponent from '$lib/components/DynamicChildrenComponent/DynamicChildrenComponent.svelte';
  import ContentExplorerItem from './ContentExplorerItem.svelte';

  export let section;
  export let entryId;
  export let index: number;
  export let isOpen: boolean;
  export let summaryEl: HTMLElement;

  const dispatch = createEventDispatcher();

  function handleToggle({ detail }: CustomEvent<{ isOpen: boolean }>) {
    const isToggled = detail.isOpen;

    if (isToggled) {
      dispatch('accordionOpen', { index, titleText: summaryEl.textContent?.trim() });
    }
  }
</script>

<AccordionItem
  class="ContentExplorerAccordion"
  data-entry-id={entryId}
  size="small"
  open={isOpen}
  disabledSelfClose={true}
  on:toggle={handleToggle}
>
  <svelte:fragment slot="summary">
    <div class="ContentExplorerAccordion__wrapper" bind:this={summaryEl}>
      {#if section.title}
        <DynamicChildrenComponent children={[section?.title]} />
      {:else}
        <p>[section.title missing!]</p>
      {/if}
    </div>
  </svelte:fragment>
  <svelte:fragment slot="content">
    <div class="ContentExplorerAccordion__content" id={`content-${index}`}>
      {#each section.items as item}
        <ContentExplorerItem {item} entryId={item.props.entryId} />
      {/each}
    </div>
  </svelte:fragment>
</AccordionItem>

<style lang="scss">
  @use '@squareup/public-web-design-system/dist/tokens/generated-tokens/scss/_media_queries' as mediaQueries;

  :global {
    .ContentExplorerAccordion {
      max-width: var(--container-width-current);
      margin: {
        right: var(--space-auto);
        left: var(--space-auto);
      }

      &:last-child {
        border-bottom: 1px solid var(--color-neutral-700);
      }
    }
  }

  .ContentExplorerAccordion__wrapper {
    :global {
      & > * {
        margin: var(--space-none);
      }
    }
  }

  .ContentExplorerAccordion__content {
    display: flex;
    flex-direction: column;
    gap: var(--space-60);
    // Match the padding of the AccordionItem summary element
    padding-bottom: var(--space-30);

    @include mediaQueries.at('medium') {
      // Offset the padding of the AccordionItem summary element
      margin-top: calc(var(--space-30) * -1);
    }

    :global {
      .AproposImageComponent,
      .VideoComponent {
        border-radius: var(--space-20);
        overflow: hidden;

        &,
        img,
        video {
          height: 100%;
          width: 100%;
        }

        img,
        video {
          object-fit: cover;
        }
      }
    }
  }
</style>
